// E-Ticaret › Ürün & Çözümler Sayfa Ayarları kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'ecommerce.productSolutions';

export const ecommerceProductSolutionsGuide = (t: TFunction): GuideContent => ({
  layout: 'tabbed',
  title: t(`${G}.title`, 'Ürün & Çözümler sayfası nasıl hazırlanır?'),
  intro: t(`${G}.intro`, 'Sitenizin Ürün & Çözümler sayfasını burada hazırlarsınız: üst başlık, ürün ve çözüm kartları, "Neden Bizi Seçmelisiniz" bölümü ve yan menüde görünen sekmeler / alt sekmeler. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Ürün & Çözümler Sayfa Ayarları'),
    tabs: t(`${G}.regions.tabs`, 'Sekmeler ve +'),
    body: t(`${G}.regions.body`, 'Bölümler'),
    footer: t(`${G}.regions.footer`, 'Sıfırla / Kaydet'),
  },
  navItems: [
    t(`${G}.nav.general`, 'Ürün & Çözümler Ayarları'),
    t(`${G}.nav.custom`, 'Özel sekmeler'),
  ],
  steps: [
    {
      region: 'body',
      title: t(`${G}.s1.title`, '1. Bölüm başlıkları ve kartlar'),
      text: t(`${G}.s1.text`, '"Hero Bölümü" sayfanın en üstündeki büyük başlık / görsel alanıdır. "Ürünler Bölümü" ve "Çözümler Bölümü"nde bölüm başlığı, açıklaması ve arka plan rengini yazın; listedeki her kart için başlık, açıklama ve renk girin. "Neden Bizi Seçmelisiniz Bölümü"nde başlık, açıklama, arka plan rengi ve özellikleri girin.'),
    },
    {
      region: 'body',
      title: t(`${G}.s2.title`, '2. Görünürlük'),
      text: t(`${G}.s2.text`, 'Her bölümün başındaki görünürlük anahtarıyla o bölümü sayfada gösterir veya gizlersiniz; gizlenen bölümün ayarları silinmez.'),
    },
    {
      region: 'tabs',
      title: t(`${G}.s3.title`, '3. Sekme ve alt sekme ekleyin'),
      text: t(`${G}.s3.text`, 'Sekmelerin sağındaki + (Yeni Sekme Ekle) sayfaya yan menüde görünen yeni bir sekme ekler (ör. Teknoloji Ürünleri, Özel Çözümler). Sekmenin içinde "Alt Sekme Ekle" ile o sekmenin altında görünecek alt sekmeler eklersiniz. Sekmeleri ve alt sekmeleri sürükleyerek sıralayın.'),
      tips: [
        t(`${G}.s3.tip1`, 'Sekme / alt sekme silme işlemi onay sorar; silinen içerik geri gelmez.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s4.title`, '4. Başlık ve içerik'),
      text: t(`${G}.s4.text`, 'Sekmede "Sekme Adı (Yan Menüde Görünür)", "Sayfa Başlığı" (üstte büyük başlık), arka plan rengi ve ana içerik (HTML editör) girilir; ek başlık-içerik bölümleri de eklenebilir. Alt sekmede "Alt Sekme Adı" zorunludur; "Sayfa Başlığı (Opsiyonel)" boş bırakılırsa ana içerikte başlık gösterilmez, yan menü adı kullanılır.'),
      tips: [
        t(`${G}.s4.tip1`, '"Durum" düğmesiyle sekmeyi / alt sekmeyi Aktif (yan menüde görünür) ya da Gizli (sayfada görünmez) yaparsınız.'),
      ],
    },
    {
      region: 'footer',
      title: t(`${G}.s5.title`, '5. Kaydet'),
      text: t(`${G}.s5.text`, 'Değişiklikler siz yazdıktan kısa bir süre sonra kendiliğinden kaydedilir; ayrıca başlıktaki "Kaydet" düğmesiyle ana sayfa ayarlarını hemen kaydedebilirsiniz. "Varsayılan ayarlara sıfırla" ana bölümleri varsayılanlara döndürür; bu hâli kalıcı yapmak için ardından "Kaydet"e basın.'),
      tips: [
        t(`${G}.s5.tip1`, 'Başlıktaki (i) düğmesi bu rehberi her zaman yeniden açar.'),
      ],
    },
  ],
});
